import '../../scripts/common';
import '../../scripts/animate';
import Sortable from 'sortablejs';
import Component from '../base/Component';

import RecommendationCard from '../RecommendationCard';
import Radio from '../base/Radio';
import Checkbox from '../base/Checkbox';
import RangeSlider from '../base/RangeSlider';
import Select from '../base/Select';
import initArticleCarousel from './articlesCarousel';

import './styles.css';

import '../../images/sprite/face_lg.svg';
import '../../images/sprite/body_lg.svg';
import '../../images/sprite/hair_lg.svg';
import '../../images/sprite/hand_lg.svg';
import '../../images/sprite/man_lg.svg';
import '../../images/sprite/woman_lg.svg';
import '../../images/sprite/baby.svg';
import '../../images/sprite/village.svg';
import '../../images/sprite/town.svg';
import '../../images/sprite/city.svg';
import '../../images/sprite/megalopolis.svg';
import '../../images/sprite/arrow_dbl.svg';

/**
 * Формы диагностики
 */
export default class DiagnosisForm extends Component {
    static className = 'diagnosis-form';
}

$(() => {
    RecommendationCard.create();
    Radio.create();
    Checkbox.create();
    initRangeSlider();
    initSelect();
    initArticleCarousel();
});

$(window).on('load', createSortable);

function initRangeSlider() {
    if ($('.range-slider--adults-age').length > 0) {
        const rangeSliderAdultsAgeObj = new RangeSlider($('.range-slider--adults-age'));
        rangeSliderAdultsAgeObj.init({
            format: 'integer',
        });
    }

    if ($('.range-slider--baby-age').length > 0) {
        const rangeSliderBabyAgeObj = new RangeSlider($('.range-slider--baby-age'));
        rangeSliderBabyAgeObj.init({
            format: 'integer',
        });
    }
}

function initSelect() {
    if ($('.select--diagnosis-types').length > 0) {
        const selectSingleDefaultObj = new Select($('.select--diagnosis-types'));
        selectSingleDefaultObj.init({
            isSearch: false,
        });
    }
}

function createSortable() {
    if ($('.js-sortable-list').length > 0) {
        const sortableList = $('.js-sortable-list')[0];
        Sortable.create(sortableList);
    }
}
